import { render } from "./shareTopic.vue?vue&type=template&id=42686fd3&scoped=true"
import script from "./shareTopic.vue?vue&type=script&lang=js"
export * from "./shareTopic.vue?vue&type=script&lang=js"

import "./shareTopic.vue?vue&type=style&index=0&id=42686fd3&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42686fd3"]])

export default __exports__